
export default {
  props: {
    activeIndex: {
      type: [Number, Boolean],
      default: null,
      required: false,
    },
  },
  inject: ["Accordion"],
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      return this.Accordion.active.includes(this.index);
    },
  },
  created() {
    this.index = this.Accordion.count++;
    if (this.activeIndex >= 0 && this.activeIndex != null) {
      this.Accordion.active.push(this.activeIndex);
    }
  },
  methods: {
    open() {
      if (this.visible && this.Accordion.active.length == 1) {
        this.Accordion.active = [];
      } else {
        this.Accordion.active = [this.index];
      }
    },
    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    },
  },
};
